var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRodbotsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.81 180.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#667eea",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#764ba2",
      stopOpacity: 1
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#logoGradient);\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoGradient)",
    d: "M14.92,76.26c2.01-.14,3.55-1.79,3.75-3.8,2.5-25.43,21.13-49.2,42.92-61.38C72.8,4.81,92.73-1.38,105.55.27c1.53.2,2.11,1.12,2.51,2.5v173.05c0,2.12-1.6,3.94-3.71,4.15-2.29.22-5.02-.02-6.34-.08-31.21-1.37-61.71-18.79-72.65-48.81-.44-1.2-1.43-2.12-2.64-2.51-8.88-2.83-15.94-8.71-19.7-17.45-5.55-12.91-4.46-33.73,11.9-34.86ZM99.89,12.99c0-2.44-2.09-4.35-4.52-4.16-30.22,2.35-58.47,26.05-66.71,54.94-2,6.99-1.58,11.35-2.3,18.17s-7.17,2.12-10.3,2.02c-4.86-.14-7.3,6.13-7.66,10.1-.89,9.74,3.47,20.63,12.57,25.01,2.14,1.03,6.06,1.72,8.39,2.96.8.42,1.43,1.1,1.81,1.92,1.77,3.87,2.94,7.88,4.99,11.67,10.18,18.82,29.66,31.55,50.68,34.95,2.82.46,5.67.64,8.51.89,2.43.21,4.52-1.71,4.52-4.15v-16.69c0-2.23-1.75-4.09-3.98-4.16-10.23-.35-20.83-3.07-28.62-9.79-2.57-2.22-8.69-8.22-5.22-11.5,4.09-3.88,6.98,2.17,9.39,4.41,6.09,5.65,15.51,8.46,24.06,8.93,2.38.13,4.37-1.79,4.37-4.17v-6.85c0-2.13-1.61-3.93-3.73-4.14-6.25-.63-16.16-2.92-17.94-6.37-1.37-2.65.42-6.02,3.49-6.04,1.97,0,2.53.95,3.98,1.49,3.24,1.21,6.21,2.15,9.4,2.68,2.52.42,4.8-1.57,4.8-4.12V12.99Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoGradient)",
    d: "M156.29,36.53v10.55c0,2.3,1.87,4.17,4.17,4.17h11.5c12.28,0,19.59,11.69,20.28,22.75.79,12.68.74,30.76,0,43.47-1.83,31.3-32.39,49.42-59.44,57.52-1.5.45-4.97,1.75-7.92,2.18-2.51.36-4.75-1.59-4.76-4.12l-.2-118.68c-.29-1.02.96-3.11,1.9-3.11h22.78c2.3,0,4.17-1.87,4.17-4.17v-10.59c0-1.55-.87-2.97-2.25-3.7-1.84-.97-3.31-2.02-4.61-4.13-4.99-8.08-.04-18.57,9.56-19.19,14.61-.95,19,17.42,7.21,23.3-1.44.72-2.38,2.15-2.38,3.76ZM151.16,17.09c-4.41,1.01-4.9,8.73.52,9.76,8.04,1.53,7.95-11.7-.52-9.76ZM128.72,162.1c0,2.84,2.79,4.87,5.48,3.96,20.98-7.12,47.59-22.43,49.27-45.67,1.14-15.78-.82-32.94-.08-48.89.01-.25,0-.49-.03-.74-.81-5.82-6.79-11.16-12.65-11.16h-37.82c-2.3,0-4.17,1.87-4.17,4.17v67.39c0,2.87,2.85,4.92,5.55,3.94,4.41-1.6,8.64-4.35,11.59-7.62,2.27-2.52,4.3-8.15,8.76-6.27.94.4,2.08,2.27,2.13,3.34.14,3.53-6.86,10.83-9.67,12.91-4.33,3.22-9.73,5.55-15.13,6.75-1.9.42-3.23,2.16-3.23,4.11v13.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoGradient)",
    d: "M151.16,17.09c8.47-1.94,8.56,11.29.52,9.76-5.43-1.03-4.94-8.75-.52-9.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoGradient)",
    d: "M67.2,50.52c4.54-.58,20.16.73,14.72,8.45-2.34,3.32-6.02.19-9.03-.16-4.45-.52-8.59.39-11.82,3.55-1.26,1.24-4.11,6.38-4.64,6.64-3.06,1.49-6.88-1.38-6.18-4.91,1.21-6.12,10.94-12.8,16.94-13.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoGradient)",
    d: "M68.03,81.42c7.95-1.35,14.37,4.24,14.31,12.22-.05,7.53-8.41,7.51-8.76,1.62-.07-1.13.56-1.8.23-3.08-.57-2.19-2.49-3.65-4.74-2.61-2.96,1.37.77,8.59-4.59,9.62-6.16,1.19-6.05-8.22-4.03-11.97,1.36-2.53,4.71-5.31,7.57-5.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoGradient)",
    d: "M152.45,78.49c15.6-1.1,17.32,24.35,1.12,24.58-15.34.21-16.42-23.5-1.12-24.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodbotsvg);
export default __webpack_public_path__ + "static/media/rodbotsvg.91893d2fcb958aaa8f42ae128b3889c7.svg";
export { ForwardRef as ReactComponent };